import {FC} from 'react'

import {SkeletonBlock} from '@/components/common/skeleton/SkeletonBlock'
import {SkeletonLoadingOverlay} from '@/components/common/skeleton/SkeletonLoadingOverlay'
import {BLOG_THUMBNAIL_HEIGHT, BLOG_THUMBNAIL_WIDTH} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

type BlogPreviewListSkeletonProps = {
  rows: number[]
}

export const BlogPreviewListSkeleton: FC<BlogPreviewListSkeletonProps> = ({rows}) => (
  <>
    <SkeletonLoadingOverlay>
      {rows.map((height, index) => (
        <div key={index} className="article" style={{height: height || undefined}}>
          <div className="wrapper">
            <div className="image">
              <SkeletonBlock width="100%" height="100%" />
            </div>
            <div className="content">
              <SkeletonBlock width={180} height={17} />
              <div className="title">
                <SkeletonBlock width="80%" height={28} />
              </div>
              <div className="intro">
                <SkeletonBlock width="100%" height={17} />
                <SkeletonBlock width="65%" height={17} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </SkeletonLoadingOverlay>

    <style jsx>{`
      .article {
        overflow: hidden;
      }

      .article + .article {
        position: relative;
        padding-top: ${theme.spacing[5]};
        margin-top: ${theme.spacing[5]};
      }

      .article + .article:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background-color: ${theme.palette.butter[100]};
      }

      .wrapper {
        display: flex;
        gap: ${theme.spacing[5]};
      }

      .image {
        width: ${BLOG_THUMBNAIL_WIDTH};
        height: ${BLOG_THUMBNAIL_HEIGHT};
        flex: 0 0 ${BLOG_THUMBNAIL_WIDTH};
      }

      .content {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        gap: ${theme.spacing[3]};
        width: 100%;
      }

      .intro {
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing[1.5]};
      }

      @media ${MOBILE_SCREENSIZE} {
        .article + .article {
          padding-top: ${theme.spacing[4]};
          margin-top: ${theme.spacing[4]};
        }

        .wrapper {
          flex-direction: column;
          gap: ${theme.spacing[3]};
        }

        .image {
          width: 100%;
          flex: inherit;
        }

        .content {
          gap: ${theme.spacing[2]};
        }
      }
    `}</style>
  </>
)
